<template>
  <div id="app" version="2.3">
    <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    />
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if (this.$store.getters.current_user) {
      this.$store.dispatch("loadBackendData");
    }
  }
};
</script>
